import Button from '../atoms/button';
import Text from '../atoms/text';

interface MVCHeaderProps {
	title: string;
	filters?: JSX.Element[];
	onCreateText?: string;
	onCreateClick?: () => void;
	onCreateDisabled?: boolean;
}

const MVCHeader = ({
	title,
	filters = [],
	onCreateText,
	onCreateClick,
	onCreateDisabled,
}: MVCHeaderProps) => (
	<div className="flex items-center gap-4">
		<Text
			className="text-primary font-semibold col-span-2 sm:col-span-1 flex-grow"
			as="h3"
		>
			{title}
		</Text>
		{filters.map((filter) => filter)}
		{onCreateText && onCreateClick && (
			<Button
				className="min-w-fit"
				onClick={onCreateClick}
				disabled={onCreateDisabled}
			>
				{onCreateText}
			</Button>
		)}
	</div>
);

export default MVCHeader;
